// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"38c72fa4","256":"125885ff","273":"c5ca4e42","871":"9e89bf03","896":"515b147a"}[chunkId] + ".js";
};